module.exports = __webpack_public_path__ + "assets/img/play.b78761ea.svg";